<div class="px-2">
    <app-navbar [isMobile]="true" (closeMobileMenu)="closeMenu()"></app-navbar>
</div>
